import script from "./GlobalCatalogsView.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalCatalogsView.vue?vue&type=script&setup=true&lang=js"

import "./GlobalCatalogsView.vue?vue&type=style&index=0&id=348db397&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-348db397"]])

export default __exports__